import React from "react";
import { useWorkplace } from "../context/WorkplaceContext";

const IntegratedControl = () => {
  const { selectedWorkplaceId } = useWorkplace(); // Context 사용
  return (
    <div>
      <h1>IntegratedControl Page</h1>
      <p>This page is accessible only for logged-in users.</p>
      <p>(적용시 없앨 예정) Selected Workplace ID: {selectedWorkplaceId}</p>
    </div>
  );
};

export default IntegratedControl;
